// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wn-0";
export var confirmationIcon = "_wn-1";